import PersonalInfoForm from './PersonalInfoForm'

export default PersonalInfoForm
